import type { InjectionKey } from "vue";
import type { TwinProperty } from "@shared/services/twinManagement";

export const clientId = "smx-shop-floor-walk";
export const roles = {
  admin: "admin",
  user: "user",
};

export const ticketType = "sfw.ticket.walk";
export const nonWalkTicketType = "sfw.ticket.!walk";
export const ticketPrefix = "sfw.ticket.*";
export const normalTicketTypeQuery = "sfw.ticket.!walk";

export const assetType = "sfw.asset.*";

export const sfwTicketProps = {
  sfwAsset: "sfwasset",
  status: "status",
  walkThroughOrder: "walkthroughOrder",
};

export type SFWNameResolver = (
  _values: Record<string, unknown>,
  _properties: TwinProperty[],
) => string | undefined;

export const SFW_NAME_RESOLVER_KEY: InjectionKey<SFWNameResolver> =
  Symbol("sfwNameResolver");
